<template>
  <div class="header">
    <div class="container v-row">
      <div class="logo-box v-row">
        <img v-if="config.WEB == 3" class="logo logo-tz" style="height: 30px" src="../../../assets/images/logo-tz.png" />
        <img v-else-if="config.WEB == 4" class="logo logo-pk" style="height: 70px" src="../../../assets/images/logo-pk-white.png" />
        <img v-else class="logo logo-default" src="../../../assets/images/logo.png" />
      </div>
      <div class="right-box">
        <router-link to="/" v-if="config.WEB != 1" class="front-btn v-row v-row-align-center v-mr-20">
          <div class="iconfont icon-home v-mr-5"></div>
          <div class="label">前台</div>
        </router-link>
        <el-dropdown class="user-info" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ nickname }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="pwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">注销登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <password v-if="isShowPwd" :show.sync="isShowPwd"></password>
  </div>
</template>

<script>
import password from './password';

export default {
  components: { password },

  data() {
    let userInfo = this.$store.getters.userInfo;
    return {
      userInfo,
      nickname: userInfo.nickname,
      isShowPwd: false,
      config: this.config,
    };
  },

  methods: {
    handleCommand(command) {
      if (command === 'pwd') {
        this.isShowPwd = true;
      }
      if (command === 'logout') {
        this.logout();
      }
    },

    //退出登录
    async logout() {
      try {
        await this.$confirm('确认退出登录么?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.$store.dispatch('user/logout');
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: #001236;
  height: 64px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
}

.container {
  width: 1200px;
  margin: 0 auto;
  justify-content: space-between;
}

.logo-box {
  display: flex;
  align-items: center;
  color: #fff;
  width: 190px;
  justify-content: center;

  .logo {
    margin-right: 14px;
    display: block;
    height: 50px;
  }
}

.right-box {
  display: flex;
  align-items: center;
  color: #fff;
}

.user-info {
  color: #fff;
  cursor: pointer;
}
.front-btn {
  margin-right: 30px;
  font-size: 13px;
  text-decoration: none;
  color: #fff;
}
.front-btn .iconfont {
  font-size: 14px;
  cursor: pointer;
}
</style>
